//Common service for dealing with small tables

app.factory(
    'ExplorerService', ['LocalStorage', 'Configuration', 'ApiService', 'Upload', '$rootScope', '$http', '$window', ExplorerService]
);

function ExplorerService(LocalStorage, Configuration, ApiService, UploadServcie, $rootScope, $http, $window) {
    self.GetIndex = GetIndex;
    self.Create = Create;
    self.Remove = Remove;
    self.Rename = Rename;
    self.Download = Download;
    self.Upload = Upload;
    self.UploadFilesForObject = UploadFilesForObject;
    self.DownloadAssociatedFile = DownloadAssociatedFile;

    function Download(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/ExplorerApi/download?path=' + path,
            params: { name: name },
            responseType: 'arraybuffer'
        }).then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: contentType });

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);                    
                } else {                    
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);                    
                    if (contentType === headers["content-type"]) {
                        linkElement.setAttribute("download", filename);
                    }

                    linkElement.setAttribute('target', '_self');

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    function DownloadAssociatedFile(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/ExplorerApi/DownloadAssociatedFile?path=' + path,
            params: { name: name },
            responseType: 'arraybuffer'
        }).then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: contentType });
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
                    linkElement.setAttribute('target', '_self');
                    linkElement.click();
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    function Upload(path, files) {
        var request = UploadServcie.upload({
            url: Configuration.api.url + "/api/ExplorerApi/Upload?path=" + path,
            data: {
                files: files
            }
        });

        return request;
    }

    function UploadFilesForObject(files) {
        var request = UploadServcie.upload({
            url: Configuration.api.url + "/api/ExplorerApi/UploadFilesForObject",
            data: {
                files: files
            }
        });

        return request;
    }

    function GetIndex(path) {
        var request = ApiService.get("/api/ExplorerApi/GetIndex?path=" + path);
        return request;
    }

    function Create(path) {
        var request = ApiService.get("/api/ExplorerApi/Create?path=" + path);
        return request;
    }

    function Remove(path) {
        var request = ApiService.get("/api/ExplorerApi/Remove?path=" + path);
        return request;
    }

    function Rename(oldvalue, newvalue) {
        var request = ApiService.get("/api/ExplorerApi/Rename?oldvalue=" + oldvalue + "&newvalue=" + newvalue);
        return request;
    }

    return self;
}